var delay = function (milliseconds) {
    return new Promise(function (resolve) {
        return setTimeout(function () {
            resolve();
        }, milliseconds);
    });
};
export default delay;
//# sourceMappingURL=delay.js.map